module.exports = {
	"contractName": "Level",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x",
	"deployedBytecode": "0x",
	"sourceMap": "",
	"deployedSourceMap": "",
	"source": "pragma solidity ^0.4.18;\n\nimport \"zeppelin-solidity/contracts/ownership/Ownable.sol\";\n\ncontract Level is Ownable {\n  function createInstance(address _player) public payable returns (address);\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool);\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
		"exportedSymbols": {
			"Level": [
				2866
			]
		},
		"id": 2867,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2846,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:28"
			},
			{
				"absolutePath": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"file": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"id": 2847,
				"nodeType": "ImportDirective",
				"scope": 2867,
				"sourceUnit": 2923,
				"src": "26:59:28",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2848,
							"name": "Ownable",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2922,
							"src": "105:7:28",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Ownable_$2922",
								"typeString": "contract Ownable"
							}
						},
						"id": 2849,
						"nodeType": "InheritanceSpecifier",
						"src": "105:7:28"
					}
				],
				"contractDependencies": [
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": false,
				"id": 2866,
				"linearizedBaseContracts": [
					2866,
					2922
				],
				"name": "Level",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": null,
						"documentation": null,
						"id": 2856,
						"implemented": false,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2852,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2851,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2856,
									"src": "141:15:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2850,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "141:7:28",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "140:17:28"
						},
						"payable": true,
						"returnParameters": {
							"id": 2855,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2854,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2856,
									"src": "182:7:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2853,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "182:7:28",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "181:9:28"
						},
						"scope": 2866,
						"src": "117:74:28",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": null,
						"documentation": null,
						"id": 2865,
						"implemented": false,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2861,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2858,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2865,
									"src": "220:17:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2857,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "220:7:28",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2860,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2865,
									"src": "239:15:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2859,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "239:7:28",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "219:36:28"
						},
						"payable": false,
						"returnParameters": {
							"id": 2864,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2863,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2865,
									"src": "280:4:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2862,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "280:4:28",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "279:6:28"
						},
						"scope": 2866,
						"src": "194:92:28",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2867,
				"src": "87:201:28"
			}
		],
		"src": "0:289:28"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
		"exportedSymbols": {
			"Level": [
				2866
			]
		},
		"id": 2867,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2846,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:28"
			},
			{
				"absolutePath": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"file": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"id": 2847,
				"nodeType": "ImportDirective",
				"scope": 2867,
				"sourceUnit": 2923,
				"src": "26:59:28",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2848,
							"name": "Ownable",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2922,
							"src": "105:7:28",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Ownable_$2922",
								"typeString": "contract Ownable"
							}
						},
						"id": 2849,
						"nodeType": "InheritanceSpecifier",
						"src": "105:7:28"
					}
				],
				"contractDependencies": [
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": false,
				"id": 2866,
				"linearizedBaseContracts": [
					2866,
					2922
				],
				"name": "Level",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": null,
						"documentation": null,
						"id": 2856,
						"implemented": false,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2852,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2851,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2856,
									"src": "141:15:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2850,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "141:7:28",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "140:17:28"
						},
						"payable": true,
						"returnParameters": {
							"id": 2855,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2854,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2856,
									"src": "182:7:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2853,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "182:7:28",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "181:9:28"
						},
						"scope": 2866,
						"src": "117:74:28",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": null,
						"documentation": null,
						"id": 2865,
						"implemented": false,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2861,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2858,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2865,
									"src": "220:17:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2857,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "220:7:28",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2860,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2865,
									"src": "239:15:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2859,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "239:7:28",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "219:36:28"
						},
						"payable": false,
						"returnParameters": {
							"id": 2864,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2863,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2865,
									"src": "280:4:28",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2862,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "280:4:28",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "279:6:28"
						},
						"scope": 2866,
						"src": "194:92:28",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2867,
				"src": "87:201:28"
			}
		],
		"src": "0:289:28"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.817Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Level.json
// module id = 1045
// module chunks = 0